import React, { useState } from 'react';

import { Field } from 'formik';
import { Box, Button } from 'lmc-ui-library';

import styles from '../profile.module.scss';
import { FIELDS, FIELDS_LABELS } from '../types';
import { PackagerProps } from './types';

const Packager: React.FC<PackagerProps> = ({ title, initialData, data, onChangeClick }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isPackagerChanged = initialData[FIELDS.IS_PACKAGER] !== data[FIELDS.IS_PACKAGER];
  const isDirty = isPackagerChanged;



  const saveHandler = async () => {
    setIsSubmitting(true);
    const isPackagerHandler = onChangeClick('is_packager');
    isPackagerHandler(data[FIELDS.IS_PACKAGER]);
    setIsSubmitting(false);
  }

  return (
    <Box title={title} className={styles.box}>
      <Box.Content>
        <div className={styles.checkboxContainer}>
          <Field type="checkbox" name={FIELDS.IS_PACKAGER} className={styles.checkbox} />
          <label htmlFor={FIELDS.IS_PACKAGER}>{FIELDS_LABELS.IS_PACKAGER}</label>
        </div>
        <div className={styles.packagerSaveBtn}>
          <Button
            type="button"
            mode="secondary"
            borderVariant="rectangle"
            onClick={saveHandler}
            disabled={!isDirty || isSubmitting}
            width="120px"
          >
            Save
          </Button>
        </div>
      </Box.Content>
    </Box>
  );
};

export default Packager;
